import React, { ChangeEvent } from 'react';
import { Box, Stack, Typography, Button, IconButton } from '@mui/material';
import { ArrowLeft, Send } from 'lucide-react';
import { TextInput } from '../../../../../../../ui/input/text_input/text_input';
import { InviteUserRequest } from '../../../../../../../utils/types/assessment_types';

type InviteSingleUserProps = {
  inviteUserDetails: InviteUserRequest;
  handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  inviteUserForAssessment: (userDetails: InviteUserRequest) => void;
  setAddSingleUser: (value: boolean) => void;
};

export const InviteSingleUser: React.FC<InviteSingleUserProps> = ({
  inviteUserDetails,
  handleInputChange,
  inviteUserForAssessment,
  setAddSingleUser,
}) => {
  return (
    <Stack spacing={3} sx={{ position: 'relative', width: '100%' }}>
      <Box sx={{ position: 'absolute', top: 0, left: 0 }}>
        <IconButton
          onClick={() => setAddSingleUser(false)}
          size="small"
          sx={{ border: '1px solid', borderColor: 'divider' }}
        >
          <ArrowLeft size={18} />
        </IconButton>
      </Box>
      <Typography variant="h6" fontWeight={700} textAlign="center" sx={{ pt: 1 }}>
        Send Email Invite
      </Typography>
      <Stack spacing={2}>
        <TextInput
          label="First Name"
          name="firstName"
          value={inviteUserDetails.firstName}
          type="text"
          onChange={handleInputChange}
        />
        <TextInput
          label="Last Name"
          name="lastName"
          value={inviteUserDetails.lastName}
          type="text"
          onChange={handleInputChange}
        />
        <TextInput
          label="Email"
          name="email"
          value={inviteUserDetails.email}
          type="text"
          onChange={handleInputChange}
        />
      </Stack>
      <Button
        onClick={() => inviteUserForAssessment(inviteUserDetails)}
        variant="contained"
        color="primary"
        fullWidth
        endIcon={<Send size={16} />}
        sx={{ textTransform: 'none', fontWeight: 600, py: 1.2, borderRadius: 1.5 }}
      >
        Send Invite
      </Button>
    </Stack>
  );
};
